import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import PackageStructureTierRow from './PackageStructureTierRow';
import type { DisplayPackage } from './PriceSimulation.types';

interface PackageStructurePackageRowProps {
    package: DisplayPackage;
    isExpanded: boolean;
    onToggle: () => void;
    expandedTiers: Record<string, boolean>;
    onToggleTier: (tierId: string) => void;
}

const PackageStructurePackageRow = ({ package: pkg, isExpanded, onToggle, expandedTiers, onToggleTier }: PackageStructurePackageRowProps) => {
    const { t } = useTranslation();

    const handleSummaryClick = (event: MouseEvent) => {
        event.preventDefault();
        onToggle();
    };

    const tierCount = pkg.tiers.length;
    const tierLabel = tierCount === 1 ? t('priceSimulation.tierSingular') : t('priceSimulation.tiers');

    return (
        <details className="collapse-list border rounded-8 overflow-hidden" open={isExpanded}>
            <summary className="collapse-list-header" onClick={handleSummaryClick}>
                <div className="collapse-list-title">
                    <SpirisIcon name="article" className="mr-8" />
                    <span className="heading-md">{pkg.name}</span>
                    <span className="d-flex align-items-center gap-12 ml-auto">
                        <span className="body-sm text-secondary">
                            {tierCount} {tierLabel}
                        </span>
                        <span className="caret caret-lg"></span>
                    </span>
                </div>
            </summary>
            {isExpanded && (
                <div className="collapse-list-content d-flex flex-column gap-8 pb-16">
                    {!pkg.hasSelectedPlan && <p className="text-secondary mb-0">{t('priceSimulation.packageMissingPlan', { months: pkg.periodMonths })}</p>}
                    {pkg.tiers.map((tier) => (
                        <PackageStructureTierRow key={tier.id} tier={tier} isExpanded={expandedTiers[tier.id] || false} onToggle={() => onToggleTier(tier.id)} />
                    ))}
                </div>
            )}
        </details>
    );
};

export default PackageStructurePackageRow;
